import React, {
  useRef,
  useState,
  useMemo,
  useEffect,
} from 'react';
import { Spinner } from '../../../../common';
import {
  useGetDepartmentQuery,
  useGetDepartmentsQuery,
} from '../../../../../redux/services/departments';
import DepartmentsTable from './DepartmentsTable.jsx';
import { routes } from '../../../../../utils/helpers/ApiClient';
import { AppBarCMS } from '../../../../basic';
import CollapseBlock from '../../../../common/blocks/CollapseBlock/CollapseBlock';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import NewsModal from '../../../PublicPages/HomePage/NewsDetail/NewsItem/NewsModal/NewsModal';
import { isNull } from 'lodash';

const DepartmentsPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const languageType = useRef(null);
  const [departmentInPreviewId, setDepartmentInPreviewId] = useState(null);

  const { data: departments, isLoading } = useGetDepartmentsQuery();

  useEffect(() => {
    document.title = t('Pracoviská FRI') + ' - FRI CMS';
  }, []); // Runs on mount

  const {
    data: departmentInPreviewDetail,
    isFetching: isLoadingDepartmentPreview,
  } = useGetDepartmentQuery(departmentInPreviewId, {
    skip: isNull(departmentInPreviewId),
  });

  const content = useMemo(() => {
    if (!departmentInPreviewDetail) return null;

    const lang = languageType.current;
    return `
      <div class="ant-collapse-header" style="margin-bottom: 1em">
        <span class="ant-collapse-header-text">${lang === 'sk' ? 'Popis pracoviska' : 'Department description'}</span>
      </div>
      <div>${departmentInPreviewDetail[`description_${lang}`]}</div>
      <div class="ant-collapse-header" style="margin-top: 3em; margin-bottom: 1em">
        <span class="ant-collapse-header-text">${lang === 'sk' ? 'Aktivity pracoviska' : 'Department activities'}</span>
      </div>
      <div>${departmentInPreviewDetail[`activities_${lang}`]}</div>
    `;
  }, [departmentInPreviewDetail]);

  return isLoading ? (
    <Spinner />
  ) : (
    <>
      <AppBarCMS
        title={t('Pracoviská FRI')}
        backUrl={routes.cmsDashboard}
        backUrlTooltip={t('Nástenka')}
        permissionsBasic="departments"
      />
      <div style={{ margin: '10px' }}>
        <CollapseBlock>
          <DepartmentsTable
            departments={departments}
            onDetailClick={(id) =>
              navigate(`${routes.cmsDepartmentEdit}/${id}`)
            }
            onPreviewClick={(record, type) => {
              setDepartmentInPreviewId(record.id);
              languageType.current = type
                ? type
                : record.title_sk
                  ? 'sk'
                  : 'en';
            }}
          />
        </CollapseBlock>
      </div>

      {departmentInPreviewId && (
        <NewsModal
          isLoading={isLoadingDepartmentPreview}
          visible
          toggleModal={() => setDepartmentInPreviewId(null)}
          content={content}
          title={departmentInPreviewDetail?.[`title_${languageType.current}`]}
        />
      )}
    </>
  );
};

export default DepartmentsPage;
